module.exports = [{
      plugin: require('../../node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["G-P1CM0RM05V"],"gtagConfig":{}},
    },{
      plugin: require('../../node_modules/gatsby-plugin-decap-cms/gatsby-browser.js'),
      options: {"plugins":[],"modulePath":"/opt/build/repo/site/src/cms/comments-management.jsx"},
    },{
      plugin: require('../../node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":1140,"quality":50,"showCaptions":true,"linkImagesToOriginal":false,"disableBgImageOnAlpha":true,"markdownCaptions":false,"backgroundColor":"white","withWebp":false,"withAvif":false,"loading":"lazy","decoding":"async","disableBgImage":false},
    },{
      plugin: require('../../node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../packages/blog/gatsby-blog-core/gatsby-browser.js'),
      options: {"plugins":[],"siteUrl":"https://www.ibrahimuylas.com","fonts":false,"homeCategoryPostsPerGroup":6,"services":{"giscus":{"repo":"ibrahimuylas/ibrahim-uylas","repoId":"MDEwOlJlcG9zaXRvcnkzMzAyODIzNzg=","category":"Blog Comments","categoryId":"DIC_kwDOE6-1is4DCaw9","theme":"light"},"comments":{"enabled":true,"turnstileSiteKey":"0x4AAAAAAEMjbEl_9LuNSnvz"},"mailchimp":true},"sources":{"local":true}},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
